// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"3e0c673e","429":"20f182a6","440":"e8499cfd","490":"ab56aa15","964":"050b219e","975":"e8499cfd"}[chunkId] + ".chunk.css";
};